var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { defaultIconProps } from '../icon';
export var IconCaretDown = function (props) { return (_jsx("span", __assign({ className: "icon icon__caret-down" }, { children: _jsx("svg", __assign({ width: "16", height: "16", viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: _jsx("path", { d: "M3.60693 5.55565C3.92565 5.24616 4.43268 5.24616 4.75141 5.55565L8 8.71005L11.2486 5.55565C11.5673 5.24616 12.0743 5.24616 12.3931 5.55565C12.7253 5.87828 12.7253 6.41167 12.3931 6.7343L8.69663 10.3236C8.30862 10.7003 7.69138 10.7003 7.30337 10.3236L3.60693 6.7343C3.27466 6.41167 3.27466 5.87828 3.60693 5.55565Z", fill: props.fill || defaultIconProps.fill }) })) }))); };
